export default "__VITE_ASSET__BDX9GWAV__"